import React, { Fragment } from 'react';
import { AboutHelmet } from '../components/MoiPayHelmet';
import AboutUsComponent from '../components/about_v2/about_us_component';

export default function About() {
  return (
    <Fragment>
      <AboutHelmet />
      <AboutUsComponent />
    </Fragment>
  );
} 